import * as leadformConstants from '../constants';
import * as fieldModel from '../field';

/**
 * Gets a list of all the active fields in the form
 */
export default function getFieldsByName(form, name){
  const selector = leadformConstants.leadformTagNames.fields
    .map((tagname) => `${tagname}[name="${name}"]`)
    .join(',');
  const nodelist = form.querySelectorAll(selector);
  return [...nodelist].filter((field) => fieldModel.isActive(field));
}



// WEBPACK FOOTER //
// ./client/app/scripts/leadform/models/form/get_fields_by_name.js